import React from 'react';
import Select, { createFilter } from "react-select";
import { Button, Form } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../_metronic/_partials/controls/Card";
import Loader from "react-loader-spinner";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  getRequest,
  Uri_GetFacility,
  getRequestQry,
  URI_GetAllResidentByFacilityID,
  URI_GetResidentWoundByResidentID,
  Uri_GetWoundDocumentationByWoundID
} from "../../General/api";
import {
  showSuccessAlertAutoClose,
  LogError,
  getInputStringDateUsingMoment2,
  showSuccessAlert,
  calculatePushScore
} from "../../General/common";
import uuid from 'node-uuid'
import moment from 'moment';
import { documentationFilterType } from '../../General/documentation-filter.enum';

/**
 * Inserts zero-width spaces into text at regular intervals to provide natural break points
 * for html2canvas PDF rendering. Fixes garbled/overflow text when long continuous strings
 * (no spaces) are rendered via html2canvas.
 */
const insertWordBreaks = (text, interval = 30) => {
  if (!text || typeof text !== 'string') return text;
  return text.replace(new RegExp(`(.{${interval}})`, 'g'), '$1\u200B');
};

export default class WoundEvaluationReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValidated: false,
      facilityList: [],
      facilitySelect: null,
      facilityForPDFName: null,
      facilityResidentList: [],
      residentSelect: null,
      residentWoundList: [],
      woundSelected: null,
      selectedWoundIds: [],
      isLoadingWounds: false,
      IsLoading: false,
      showReport: false,
      wound: {
        FacilityId: null,
        ResidentId: null,
        WoundId: null,
      },
      woundEvaluations: [],
      isAllWoundsSelected: false,
      isPrinting: false,
      isSearchingReport: false
    }
  }

  componentDidMount() {
    this.getAllFacility();
  }

  getAllFacility() {
    getRequest(Uri_GetFacility + "?isAssessmentView=1")
      .then((res) => {

        if (res.data.statusCode === 200) {
          if (res.data.result != null) {

            if (res.data.result.length > 0) {
              let facilityList = res.data.result.map(facility => (
                { value: facility.id, label: facility.facilityName }
              )).sort((a, b) => a.label.localeCompare(b.label));

              this.setState({ facilityList: facilityList, IsLoading: true })
            }
          }
        }
      }).catch((error) => {
        console.error(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
      });
  }

  onFacilityChange = (facility) => {
    this.setState({
      facilityResidentList: [],
      residentWoundList: [],
      facilitySelect: facility,
      residentSelect: null,
      woundSelected: null,
      selectedWoundIds: [],
      isLoadingWounds: false
    })

    if (facility) {
      // Align resident list with Assessment Queue resident source.
      getRequestQry(URI_GetAllResidentByFacilityID, `?facilityID=${facility.value}&residentStatusId=36&isAssessmentQueue=1`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            const data = res.data.result;
            let optionTemplate = data.map((resident) => (
              { value: resident.id, label: `${resident.lastName || ''} ${resident.firstName || ''}`.trim() }
            )).sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ facilityResidentList: optionTemplate })
          } else {
            this.setState({ facilityResidentList: [] })
          }
        })
        .catch((error) => {
          console.log(error)
          showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
        });
    }
  }

  onResidentChange = (resident) => {
    this.setState({
      residentWoundList: [],
      residentSelect: resident,
      woundSelected: null,
      selectedWoundIds: [],
      isLoadingWounds: false
    })

    if (resident) {
      // Show loading state immediately
      this.setState({ isLoadingWounds: true });
      
      // Align wound list with AQ wound scope (assessment/documentation entries).
      getRequestQry(URI_GetResidentWoundByResidentID, `?id=${resident.value}&isDocumentationOnly=${documentationFilterType.Assessment}`)
        .then((res) => {
          if (res.data.statusCode === 200 && res.data.result != null && res.data.result.length > 0) {
            // Optimize: Only store essential data (ID and label), not full objects
            let residentWoundList = res.data.result.map(element => (
              { 
                value: element.wound.id, 
                label: `[${element.wound.isOpen ? 'Open' : 'Closed'}] ${moment(element.wound.evaluationDate).format('MM/DD/YYYY')} - ${!!element.wound.orientationLeftRightName ? `${element.wound.orientationLeftRightName} - ` : ''}${element.wound.bodyRegion ? element.wound.bodyRegion : ''}${element.wound.bodyRegion && element.residentWoundLocation ? '/' : ''}${element.residentWoundLocation ? element.residentWoundLocation : ''}`
              }
            )).sort((a, b) => a.label.localeCompare(b.label));
            
            this.setState({ 
              residentWoundList: residentWoundList,
              isLoadingWounds: false
            })
          } else {
            this.setState({ 
              residentWoundList: [],
              isLoadingWounds: false
            })
          }
        }).catch((error) => {
          console.log(error)
          this.setState({ isLoadingWounds: false })
          showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
          LogError(error, "ResidentWound", "Get");
        });
    }
  }

  handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allWoundIds = this.state.residentWoundList.map(wound => wound.value);
      this.setState({ 
        selectedWoundIds: allWoundIds,
        isAllWoundsSelected: true
      });
    } else {
      this.setState({ 
        selectedWoundIds: [],
        isAllWoundsSelected: false
      });
    }
  }

  handleWoundCheckboxChange = (woundId, event) => {
    const isChecked = event.target.checked;
    let updatedSelectedIds = [...this.state.selectedWoundIds];
    
    if (isChecked) {
      updatedSelectedIds.push(woundId);
    } else {
      updatedSelectedIds = updatedSelectedIds.filter(id => id !== woundId);
    }
    
    const allSelected = updatedSelectedIds.length === this.state.residentWoundList.length;
    
    this.setState({ 
      selectedWoundIds: updatedSelectedIds,
      isAllWoundsSelected: allSelected && updatedSelectedIds.length > 0
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    // Validate that at least one wound is selected
    if (!this.state.selectedWoundIds || this.state.selectedWoundIds.length === 0) {
      showSuccessAlert("Please select at least one wound", "warning", "warning!", 3000);
      return;
    }

    this.setState({ facilityForPDFName: this.state.facilitySelect.label });

    const orientationEnum = {
      LEFT: 2,
      RIGHT: 1,
    }

    const getOrientation = (orientation) => {
      switch (orientation) {
        case orientationEnum.LEFT:
          return "Left - "
        case orientationEnum.RIGHT:
          return "Right - "
        default:
          return ""
      }
    }

    // Always use selected wound IDs so report scope exactly matches UI selection.
    const woundIdsParam = this.state.selectedWoundIds.join(',');
    const queryString = `?woundIDs=${woundIdsParam}`;
    this.setState({ isSearchingReport: true });

    getRequestQry(Uri_GetWoundDocumentationByWoundID, queryString)
      .then((res) => {
        if (res.data.statusCode === 200) {
          if (res.data.result != null) {
            // Check if result is array (all wounds) or single object (one wound)
            const isArray = Array.isArray(res.data.result);
            let woundEvaluationsList = isArray ? res.data.result : [res.data.result];

            let processedWounds = woundEvaluationsList.map((woundData) => {
              let tempObj = {
                residentName: woundData.residentName,
                physicianName: woundData.physicianName,
                facilityName: woundData.facilityName,
                facilityAddress: woundData.facilityAddress,
                room: woundData.room,
                woundLocation: woundData.woundLocation,
                bodyRegionName: woundData.bodyRegionName,
                skinUlcerTreatmentValues: woundData.skinUlcerTreatmentValues,
                woundId: woundData.Fk_WoundId,
                orientation: getOrientation(
                  woundData.woundEvaluationDetail?.find(wound => !!wound.orientationLeftRight)?.orientationLeftRight
                ),
                woundType: woundData.woundType,
                acquisition: woundData.acquisition,
                woundEvaluationDetail: woundData.woundEvaluationDetail || []
              };

              var evaluationDateArray = [];
              var uvc = 0;
              let formattedData = (tempObj.woundEvaluationDetail || []).sort((a, b) => new Date(a.evaluationDate) - new Date(b.evaluationDate));
              formattedData.forEach(wound => {
                uvc = uvc + 10;
                evaluationDateArray.push({
                  name: getInputStringDateUsingMoment2(moment.utc(wound.evaluationDate).local()), 
                  uv: uvc
                });
              });
              tempObj.evaluationDateArray = evaluationDateArray;

              return tempObj;
            });

            this.setState({ woundEvaluations: processedWounds, showReport: true });
          } else {
            showSuccessAlert("Record not found", "warning", "warning!", 3000);
            this.setState({ showReport: false })
          }
        }
      })
      .catch((error) => {
        console.error(error);
        showSuccessAlertAutoClose('Sorry, an error has occurred.', 'warning', 'warning!', 3000)
      })
      .finally(() => {
        this.setState({ isSearchingReport: false });
      })
  }

  handleClearFilters = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      facilitySelect: null,
      residentSelect: null,
      woundSelected: null,
      selectedWoundIds: [],
      facilityResidentList: [],
      residentWoundList: [],
      isLoadingWounds: false,
      showReport: false,
      wound: {
        FacilityId: null,
        ResidentId: null,
        WoundId: null,
      },
      woundEvaluations: [],
      isAllWoundsSelected: false
    })

  }

  /**
   * Generates PDF using content pagination: each page is built to fit within
   * PAGE_HEIGHT, and tables are split by row with thead repeated on new pages.
   * Prevents any content from being cut off by fixed-pixel slicing.
   */
  generatePDF = async () => {
    // 1. UX: Set Loading State
    this.setState({ isPrinting: true });

    // Allow UI to update before heavy lifting
    await new Promise(resolve => setTimeout(resolve, 100));

    try {
      const PAGE_WIDTH = 1100;
      const PAGE_HEIGHT = 750;
      const MARGIN = 20;

      const source = document.querySelector('#printit');
      if (!source) {
        this.setState({ IsLoading: false });
        return;
      }

      const clone = source.cloneNode(true);
      const printContainer = document.createElement('div');
      printContainer.className = 'pdf-print-pages wound-evaluation-report_content';
      // CSS Optimization: Compact layout to fit more content per page
      printContainer.style.cssText = 'position:absolute;left:-9999px;top:0;width:' + (PAGE_WIDTH + MARGIN * 2) + 'px;background:#fff;';
      printContainer.appendChild(document.createElement('style')).textContent = `
        .pdf-print-pages td { 
          word-wrap: break-word !important; 
          word-break: break-word !important; 
          overflow-wrap: break-word !important; 
          white-space: normal !important; 
          max-width: 100% !important;
          overflow-x: hidden !important;
          box-sizing: border-box !important;
          padding: 4px 8px !important; /* Compact padding */
          font-size: 0.85rem !important; /* Slightly smaller font for density */
        }
        .pdf-print-pages .border_bottom_cus { 
          word-wrap: break-word !important; 
          word-break: break-word !important; 
          overflow-wrap: break-word !important; 
          max-width: 100% !important;
          overflow-x: hidden !important;
          padding-top: 2px !important; 
          padding-bottom: 2px !important;
        }
        .pdf-print-pages p { 
          word-wrap: break-word !important; 
          word-break: break-word !important; 
          overflow-wrap: break-word !important; 
          white-space: normal !important; 
          max-width: 100% !important;
          overflow-x: hidden !important;
          margin-bottom: 2px !important;
        }
        .pdf-print-pages span { 
          word-wrap: break-word !important; 
          word-break: break-word !important; 
          overflow-wrap: break-word !important; 
          white-space: normal !important; 
          max-width: 100% !important;
          overflow-x: hidden !important;
        }
        .pdf-print-pages h2 { font-size: 1.5rem !important; margin-bottom: 5px !important; }
        .pdf-print-pages h3 { font-size: 1.2rem !important; margin-bottom: 5px !important; }
        .pdf-print-pages table { table-layout: fixed !important; margin-bottom: 0 !important; }
      `;
      document.body.appendChild(printContainer);

      const createPage = () => {
        const page = document.createElement('div');
        page.style.cssText = 'width:' + PAGE_WIDTH + 'px;max-height:' + PAGE_HEIGHT + 'px;overflow:hidden;padding:' + MARGIN + 'px;background:#fff;box-sizing:border-box;position:relative;';
        printContainer.appendChild(page);
        return page;
      };

      const children = Array.from(clone.children);
      let currentPage = createPage();
      const pages = [currentPage];

      // --- Pagination Logic ---
      for (const child of children) {
        const tableEl = child.querySelector && child.querySelector('table.table-striped');
        const tableWrapper = tableEl && tableEl.parentElement;

        if (!tableWrapper) {
          currentPage.appendChild(child);
          if (currentPage.scrollHeight > PAGE_HEIGHT) {
            currentPage.removeChild(child);
            currentPage = createPage();
            pages.push(currentPage);
            currentPage.appendChild(child);
          }
          continue;
        }

        const woundBlock = child;
        const childrenArray = Array.from(woundBlock.children);
        const tableWrapperIndex = childrenArray.indexOf(tableWrapper);
        const contentBefore = childrenArray.slice(0, tableWrapperIndex);

        // Extract rows BEFORE placing the header so widow-check can reference them safely
        const tbody = tableEl.querySelector('tbody');
        const rows = Array.from(tbody ? tbody.querySelectorAll('tr') : []);

        // IMPORTANT: table pagination must be tracked per-wound, not per-page.
        // Otherwise rows from one wound can be appended into another wound's table,
        // causing missing sections / large blank gaps in the generated PDF.
        let activeTableWrapper = null;
        let activeTbody = null;
        const ensureWoundTableOnPage = () => {
          activeTableWrapper = tableWrapper.cloneNode(false);
          const newTable = tableEl.cloneNode(true);
          const newTbody = newTable.querySelector('tbody');
          if (newTbody) newTbody.innerHTML = '';
          activeTableWrapper.appendChild(newTable);
          currentPage.appendChild(activeTableWrapper);
          activeTbody = newTable.querySelector('tbody');
        };

        if (contentBefore.length > 0) {
          const headerWrapper = document.createElement('div');
          headerWrapper.style.marginBottom = '0';
          contentBefore.forEach((n) => headerWrapper.appendChild(n));
          currentPage.appendChild(headerWrapper);
          
          let headerMoved = false;
          if (currentPage.scrollHeight > PAGE_HEIGHT) {
            currentPage.removeChild(headerWrapper);
            currentPage = createPage();
            pages.push(currentPage);
            currentPage.appendChild(headerWrapper);
            headerMoved = true;
          }

          // Widow Check: If header fits but first row doesn't, move header to next page
          // Only perform this check if we haven't already moved the header to a fresh page
          if (!headerMoved && rows.length > 0) {
             const tempWrapper = tableWrapper.cloneNode(false);
             const tempTable = tableEl.cloneNode(true);
             const tempTbody = tempTable.querySelector('tbody');
             if (tempTbody) {
                tempTbody.innerHTML = '';
                tempTbody.appendChild(rows[0].cloneNode(true));
                tempWrapper.appendChild(tempTable);
                
                currentPage.appendChild(tempWrapper);
                const isWidow = currentPage.scrollHeight > PAGE_HEIGHT;
                currentPage.removeChild(tempWrapper);

                if (isWidow) {
                   currentPage.removeChild(headerWrapper);
                   currentPage = createPage();
                   pages.push(currentPage);
                   currentPage.appendChild(headerWrapper);
                }
             }
          }
        }

        for (let r = 0; r < rows.length; r++) {
          const row = rows[r];
          const rowClone = row.cloneNode(true);

          if (!activeTbody) {
            ensureWoundTableOnPage();
          }

          activeTbody.appendChild(rowClone);

          if (currentPage.scrollHeight > PAGE_HEIGHT) {
            activeTbody.removeChild(rowClone);
            if (activeTbody.querySelectorAll('tr').length === 0 && activeTableWrapper) {
              currentPage.removeChild(activeTableWrapper);
            }
            currentPage = createPage();
            pages.push(currentPage);
            // new page => create a new table for THIS wound and continue
            activeTableWrapper = null;
            activeTbody = null;
            ensureWoundTableOnPage();
            activeTbody.appendChild(rowClone);
          }
        }
      }

      // --- Parallel Rendering Strategy ---
      const renderPageImage = async (page, index) => {
        // Unlock height for full capture
        page.style.maxHeight = 'none';
        page.style.overflow = 'visible';
        
        const canvas = await html2canvas(page, {
          scale: 1.5, // Optimization: 1.5 is good enough for print, faster than 2
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff',
          width: page.offsetWidth,
          height: page.scrollHeight 
        });
        return { 
          index, 
          imgData: canvas.toDataURL('image/png', 0.8), // Compression
          width: canvas.width,
          height: canvas.height
        };
      };

      // Run all page renders in parallel
      const imagePromises = pages.map((page, i) => renderPageImage(page, i));
      const pageImages = await Promise.all(imagePromises);
      
      // Ensure order is preserved
      pageImages.sort((a, b) => a.index - b.index);

      // --- PDF Assembly ---
      const doc = new jsPDF('landscape', 'pt', 'a4', false); // false = no compression (faster generation)
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();

      pageImages.forEach((img, i) => {
        if (i > 0) doc.addPage();
        
        const maxImgHeight = pdfHeight - 25;
        let imgPdfWidth = pdfWidth - 20;
        let imgPdfHeight = (img.height * imgPdfWidth) / img.width;
        
        if (imgPdfHeight > maxImgHeight) {
          imgPdfHeight = maxImgHeight;
          imgPdfWidth = (img.width * maxImgHeight) / img.height;
        }
        
        doc.addImage(img.imgData, 'PNG', 10, 10, imgPdfWidth, imgPdfHeight, undefined, 'FAST');
        doc.setFontSize(8);
        doc.setTextColor(112, 108, 108);
        doc.text('Page ' + (i + 1) + ' of ' + pages.length, pdfWidth - 50, pdfHeight - 20);
      });

      document.body.removeChild(printContainer);
      doc.save((this.state.facilityForPDFName || 'Report') + ' - Wound Evaluation Report.pdf');

    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      this.setState({ isPrinting: false });
    }
  };

  renderWoundForm() {
    return (
      <>{
        (this.state.IsLoading) ?
          <form onSubmit={e => this.handleSubmit(e)}>
            <div className='row'>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="FacilityName">Facility Name</label>
                  <Select
                    options={this.state.facilityList}
                    id="facilityId"
                    name="facilityId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={e => this.onFacilityChange(e)}
                    value={this.state.facilitySelect}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="PatientName">Resident Name</label>
                  <Select
                    options={this.state.facilityResidentList}
                    id="residentId"
                    name="residentId"
                    required
                    isSearchable
                    isClearable
                    filterOption={createFilter({ matchFrom: 'start' })}
                    onChange={e => this.onResidentChange(e)}
                    value={this.state.residentSelect}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <div className="form-group">
                  <label className="form-label" htmlFor="WoundType">Select Wounds</label>
                  <div style={{ 
                    border: '1px solid #ced4da', 
                    borderRadius: '4px', 
                    minHeight: '38px',
                    backgroundColor: '#fff',
                    position: 'relative'
                  }}>
                    {this.state.isLoadingWounds ? (
                      <div className="d-flex align-items-center justify-content-center" style={{ padding: '20px' }}>
                        <Loader
                          type="ThreeDots"
                          color="#0066cc"
                          height={30}
                          width={30}
                        />
                        <span className="ml-2 text-muted" style={{ fontSize: '0.875rem' }}>Loading wounds...</span>
                      </div>
                    ) : this.state.residentWoundList.length > 0 ? (
                      <div style={{ 
                        padding: '10px', 
                        maxHeight: '200px', 
                        overflowY: 'auto'
                      }}>
                        <div className="form-check mb-2" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px' }}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="selectAllWounds"
                            checked={this.state.isAllWoundsSelected && this.state.selectedWoundIds.length === this.state.residentWoundList.length}
                            onChange={this.handleSelectAll}
                          />
                          <label className="form-check-label font-weight-bold" htmlFor="selectAllWounds">
                            Select All
                          </label>
                        </div>
                        {this.state.residentWoundList.map((wound) => (
                          <div key={wound.value} className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`wound-${wound.value}`}
                              checked={this.state.selectedWoundIds.includes(wound.value)}
                              onChange={(e) => this.handleWoundCheckboxChange(wound.value, e)}
                            />
                            <label className="form-check-label" htmlFor={`wound-${wound.value}`} style={{ fontSize: '0.9rem' }}>
                              {wound.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : !this.state.residentSelect ? (
                      <div className="d-flex align-items-center" style={{ padding: '10px 15px', color: '#6c757d' }}>
                        <i className="fas fa-info-circle mr-2" style={{ fontSize: '0.875rem' }}></i>
                        <span style={{ fontSize: '0.875rem' }}>Select a resident to view wounds</span>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center" style={{ padding: '10px 15px', color: '#6c757d' }}>
                        <i className="fas fa-exclamation-circle mr-2" style={{ fontSize: '0.875rem' }}></i>
                        <span style={{ fontSize: '0.875rem' }}>No wounds found for this resident</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-end py-3'>
              <Button type='submit' variant="success" className="mr-5 px-10" size="sm" disabled={this.state.isSearchingReport}>
                {this.state.isSearchingReport ? (
                  <span className="d-flex align-items-center">
                    <Loader
                      type="ThreeDots"
                      color="#ffffff"
                      height={14}
                      width={24}
                    />
                    <span className="ml-2">Searching...</span>
                  </span>
                ) : (
                  'Search Report'
                )}
              </Button>
              <button className='btn btn-danger btn-sm' disabled={this.state.isSearchingReport} onClick={e => this.handleClearFilters(e)}>Clear filter</button>
            </div>
          </form> :
          <div className="d-flex justify-content-center">
            <Loader
              type="Puff"
              color="#00BFFF"
              height={50}
              width={50}
            />
          </div>
      }
      </>
    );
  }

  render() {
    return (
      <>
        <Card>
          <CardHeader className='Text-center' title='Wound Evaluation Report'>
            <CardHeaderToolbar>
              <div className="example-tools">

              </div>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            {this.renderWoundForm()}
            <hr />
            {this.state.showReport && this.state.woundEvaluations.length > 0 && <>
              <div className='row'>
                <div className='col-12'>
                  <button type="button" onClick={() => this.generatePDF()} disabled={this.state.isPrinting} className="mr-3 btn btn-success btn-sm float-right">{this.state.isPrinting ? 'Printing...' : 'Print Report'}</button>
                </div>
              </div>
              <div className='wound-evaluation-report'>
                <style>{`
                  #printit td {
                    word-wrap: break-word !important;
                    word-break: break-word !important;
                    overflow-wrap: break-word !important;
                    white-space: normal !important;
                    max-width: 100% !important;
                    overflow-x: hidden !important;
                    box-sizing: border-box !important;
                  }
                  #printit .border_bottom_cus {
                    word-wrap: break-word !important;
                    word-break: break-word !important;
                    overflow-wrap: break-word !important;
                    max-width: 100% !important;
                    overflow-x: hidden !important;
                  }
                  #printit p {
                    word-wrap: break-word !important;
                    word-break: break-word !important;
                    overflow-wrap: break-word !important;
                    white-space: normal !important;
                    max-width: 100% !important;
                    overflow-x: hidden !important;
                  }
                  #printit span {
                    word-wrap: break-word !important;
                    word-break: break-word !important;
                    overflow-wrap: break-word !important;
                    white-space: normal !important;
                    max-width: 100% !important;
                    overflow-x: hidden !important;
                  }
                  #printit table {
                    table-layout: fixed !important;
                  }
                `}</style>
                <div id="printit" className='printDiv wound-evaluation-report_content'>
                  {/* Show facility/resident info once at top when viewing multiple wounds */}
                  {this.state.woundEvaluations.length > 1 && (
                    <div className='mb-4'>
                      <div className='mt-3'>
                        <h2>{this.state.woundEvaluations[0].facilityName}</h2>
                        <span>{this.state.woundEvaluations[0].facilityAddress}</span>
                      </div>
                      <div className='mt-3'>
                        <table className='w-100'>
                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                <span className='font-weight-bolder mr-2'>Resident:</span>
                                <span>{this.state.woundEvaluations[0].residentName}</span>
                              </td>
                              <td>
                                <span className='font-weight-bolder mr-2'>Room:</span>
                                <span>{this.state.woundEvaluations[0].room}</span>
                              </td>
                              <td>
                                <span className='font-weight-bolder mr-2'>Physician:</span>
                                <span>{this.state.woundEvaluations[0].physicianName}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className='mt-4 mb-4' style={{ borderBottom: '2px solid #333', paddingBottom: '10px' }}>
                        <h4 style={{ color: '#0066cc', fontWeight: 'bold', margin: 0 }}>
                          {this.state.isAllWoundsSelected ? 'All Wounds' : 'Selected Wounds'} Report - {this.state.woundEvaluations.length} {this.state.woundEvaluations.length === 1 ? 'Wound' : 'Wounds'}
                        </h4>
                      </div>
                    </div>
                  )}

                  {this.state.woundEvaluations.map((woundEvaluation, woundIndex) => (
                    <div key={woundEvaluation.woundId || woundIndex} style={{ 
                      marginBottom: woundIndex < this.state.woundEvaluations.length - 1 ? '40px' : '0',
                      paddingBottom: woundIndex < this.state.woundEvaluations.length - 1 ? '30px' : '0',
                      borderBottom: woundIndex < this.state.woundEvaluations.length - 1 ? '3px solid #000' : 'none'
                    }}>
                      {/* Wound Location Header - Show for ALL wounds */}
                      <div className='mb-4' style={{ 
                        backgroundColor: '#f0f8ff', 
                        padding: '15px', 
                        borderRadius: '5px',
                        borderLeft: '5px solid #0066cc'
                      }}>
                        <h3 style={{ 
                          color: '#0066cc', 
                          fontWeight: 'bold', 
                          margin: 0,
                          fontSize: '1.3rem'
                        }}>
                          Wound {woundIndex + 1}: {woundEvaluation.orientation || ''}{woundEvaluation.bodyRegionName || ''}{woundEvaluation.bodyRegionName && woundEvaluation.woundLocation ? ' / ' : ''}{woundEvaluation.woundLocation || ''}
                        </h3>
                        <div className='mt-2' style={{ fontSize: '0.95rem', color: '#555' }}>
                          <span className='mr-4'><strong>Site#:</strong> {woundEvaluation.woundId}</span>
                          <span className='mr-4'><strong>Type:</strong> {woundEvaluation.woundType || 'N/A'}</span>
                          <span><strong>Acquisition:</strong> {woundEvaluation.acquisition || 'N/A'}</span>
                        </div>
                      </div>

                      {/* Show facility/resident info for single wound view */}
                      {this.state.woundEvaluations.length === 1 && (
                        <>
                          <div className='mt-5'>
                            <h2>{woundEvaluation.facilityName}</h2>
                            <span>{woundEvaluation.facilityAddress}</span>
                          </div>
                          <div className='mt-5'>
                            <table className='w-100'>
                              <tbody>
                                <tr>
                                  <td colSpan={2}>
                                    <span className='font-weight-bolder mr-2'>Resident:</span>
                                    <span>{woundEvaluation.residentName}</span>
                                  </td>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Room:</span>
                                    <span>{woundEvaluation.room}</span>
                                  </td>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Physician:</span>
                                    <span>{woundEvaluation.physicianName}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Site#:</span>
                                    <span>{woundEvaluation.woundId}</span>
                                  </td>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Body Region/Location:</span>
                                    <span>{woundEvaluation.orientation}{(woundEvaluation.bodyRegionName != null && woundEvaluation.bodyRegionName != "" ? woundEvaluation.bodyRegionName + " / " : "") + (woundEvaluation.woundLocation || "")}</span>
                                  </td>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Type of Wound:</span>
                                    <span>{woundEvaluation.woundType}</span>
                                  </td>
                                  <td>
                                    <span className='font-weight-bolder mr-2'>Acquistion:</span>
                                    <span>{woundEvaluation.acquisition}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      <div className={this.state.isAllWoundsSelected ? 'mt-3' : 'mt-5'}>
                        <table className='table table-striped table-sm w-100' style={{ tableLayout: 'fixed', wordWrap: 'break-word' }}>
                          <thead className='thead_style_cust'>
                            <tr>
                              <th width="10%" style={{ borderBottom: "1px solid black", backgroundColor: '#fff' }}></th>
                              <th width="14%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Measurements <span>(cm)</span></th>
                              <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Exudate</th>
                              <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Wound Bed</th>
                              <th width="12%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px' }}>Periwound</th>
                              <th width="40%" style={{ border: 'solid #000', borderWidth: '0 1px 1px 1px', wordWrap: 'break-word', maxWidth: '40%', boxSizing: 'border-box' }}>Comments</th>
                            </tr>
                          </thead>
                          <tbody className='body_style_cust'>
                            {woundEvaluation.woundEvaluationDetail?.map((wound) => {
                              return (
                                <tr key={uuid()} style={{ border: "1px solid black", wordWrap: 'break-word' }}>
                                  <td style={{ wordWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top', width: '10%' }}>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Date:</span> {getInputStringDateUsingMoment2(
                                        moment(wound.evaluationDate))}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Thickness/</span> </p>
                                      <p className='mb-0'><span className='font-weight-bolder'>Stage:</span> {wound.woundThicknessName}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Tissue type:</span> {wound.woundSevereTissueName}</p>
                                    </div>
                                  </td>
                                  <td style={{ wordWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top', width: '14%' }}>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>L</span> {wound.woundLength} <span className='font-weight-bolder'>W</span> {wound.woundWidth} <span className='font-weight-bolder'>D</span> {wound.woundDepth}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Tunneling:</span>{wound.tunneling ? "Yes" : "No"} </p>
                                      <p className='mb-0'><span className='font-weight-bolder'>Depth:</span>{wound.tunnelingDepth}</p>
                                      <p className='mb-0'><span className='font-weight-bolder'>Clock position:</span> {wound.tunnelingClockPosition}</p>
                                    </div>
                                    {wound.undermining &&
                                      <div className='border_bottom_cus py-2'>
                                        <p className='mb-0'><span className='font-weight-bolder'>Undermining:</span> {wound.undermining ? "Yes" : "No"}</p>
                                        <p className='mb-0'><span className='font-weight-bolder'>Depth:</span> {wound.underminingDepth}</p>
                                        <p className='mb-0'><span className='font-weight-bolder'>From Clock position:</span> {wound.underminingClockPosition}</p>
                                        <p className='mb-0'><span className='font-weight-bolder'>To Clock position:</span> {wound.toUnderminingClockPosition}</p>
                                      </div>
                                    }
                                  </td>
                                  <td style={{ wordWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top', width: '12%' }}>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Color:</span> {wound.exudateColor}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Exudate Type:</span> {wound.exudateTypeName}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Debridement:</span> {wound.debridementTypeName}</p>
                                      <p className='mb-0'><span className='font-weight-bolder'>Last Debridement Date:</span> {wound.debridementDate != null ? getInputStringDateUsingMoment2(moment(wound.debridementDate)) : "N/A"}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Amount:</span> {wound.exudateAmountName}</p>
                                    </div>
                                  </td>
                                  <td style={{ wordWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top', width: '12%' }}>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Odor:</span>{wound.odor ? "Yes" : "No"}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Pain:</span>{wound.pain ? "Yes" : "No"} </p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Pain Medication ordered:</span> {wound.painMedicationOrdered ? "Yes" : "No"}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Push Score: </span>
                                      {calculatePushScore(wound.woundLength * wound.woundWidth, wound.amount, wound.fkWoundSevereTissueTypeId)}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Wound Bed Description:</span></p>
                                      {wound.granulationPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Granulation %:</span>{wound.granulationPerc} </p>}
                                      {wound.hyperGranulationPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>HyperGranulation %:</span>
                                        {wound.hyperGranulationPerc} </p>}
                                      {wound.sloughPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Slough %:</span>{wound.sloughPerc} </p>}
                                      {wound.necroticPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Necrotic/Eschar %:</span>{wound.necroticPerc} </p>}
                                      {wound.epithelialPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Epithelial %:</span>{wound.epithelialPerc} </p>}
                                      {wound.musclePerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>Muscle, Tendon or Bone %:</span>{wound.musclePerc} </p>}
                                      {wound.otherPerc > 0 && <p className='mb-0'><span className='font-weight-bolder'>{wound.otherWoundDesc || wound.otherPerc} %:</span>{wound.otherPerc} </p>}
                                    </div>
                                  </td>
                                  <td style={{ wordWrap: 'break-word', wordBreak: 'break-word', verticalAlign: 'top', width: '12%' }}>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Wound Edges:</span> {wound.woundEdgesName}</p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Surrounding Skin:</span> {wound.wounSurroundingSkinName}</p>
                                      {wound.wounSurroundingSkinName === "Other" &&
                                        <p className='mb-0'><span className='font-weight-bolder'>Surrounding Skin Other:</span> {wound.otherSurroundingSkin}</p>
                                      }
                                    </div>

                                  </td>
                                  <td style={{ 
                                    wordWrap: 'break-word', 
                                    wordBreak: 'break-word', 
                                    overflowWrap: 'break-word',
                                    verticalAlign: 'top',
                                    width: '40%',
                                    maxWidth: '40%',
                                    overflowX: 'hidden',
                                    boxSizing: 'border-box'
                                  }}>
                                    <div className='border_bottom_cus py-2' style={{ 
                                      wordWrap: 'break-word', 
                                      wordBreak: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: '100%',
                                      overflowX: 'hidden'
                                    }}>
                                      <p className='mb-0' style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%', overflowX: 'hidden' }}>
                                        <span className='font-weight-bolder'>Skin & Ulcer treatment:</span> 
                                        <span style={{ 
                                          display: 'block', 
                                          marginTop: '2px', 
                                          wordWrap: 'break-word',
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                          whiteSpace: 'normal',
                                          maxWidth: '100%',
                                          overflowX: 'hidden'
                                        }}>
                                          {woundEvaluation?.skinUlcerTreatmentValues ? insertWordBreaks(woundEvaluation.skinUlcerTreatmentValues.join("- ")) : 'N/A'}
                                        </span>
                                      </p>
                                      <p className='mb-0 mt-2' style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%', overflowX: 'hidden' }}>
                                        <span className='font-weight-bolder'>Treatment:</span> 
                                        <span style={{ 
                                          display: 'block', 
                                          marginTop: '2px', 
                                          wordWrap: 'break-word', 
                                          wordBreak: 'break-word', 
                                          overflowWrap: 'break-word', 
                                          whiteSpace: 'normal',
                                          maxWidth: '100%',
                                          overflowX: 'hidden'
                                        }}>
                                          {wound.treatment ? insertWordBreaks(wound.treatment) : 'N/A'}
                                        </span>
                                      </p>
                                      <p className='mb-0 mt-2' style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%', overflowX: 'hidden' }}>
                                        <span className='font-weight-bolder'>General Comments:</span>
                                        <span style={{ 
                                          display: 'block', 
                                          marginTop: '2px', 
                                          wordWrap: 'break-word',
                                          wordBreak: 'break-word',
                                          overflowWrap: 'break-word',
                                          whiteSpace: 'normal',
                                          maxWidth: '100%',
                                          overflowX: 'hidden'
                                        }}>
                                          {wound.comments || 'N/A'}
                                        </span>
                                      </p>
                                    </div>
                                    <div className='border_bottom_cus py-2'>
                                      <p className='mb-0'><span className='font-weight-bolder'>Signature:</span> {wound.evaluatedBy || 'N/A'}</p>
                                      <p className='mb-0'>[E-signed] {moment(wound.evaluationDate).format('MM/DD/YYYY hh:mm A')}</p>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
            }
          </CardBody>
        </Card>

      </>
    );
  }
}